module.exports = __webpack_public_path__ + "static/scale-model-of-kansas-city-missouri-3f1792d953911aa763a648e1d50ab45d.png";